import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 12',
    id: 'WB3-U12-P80-E1',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page80/E1/Key/answerKey.png',
    textAlign: 'center',
    maxLength: 1,
    padding: 0,
    isHiddenCheck:true,
    inputSize: 20,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page80/2.jpg' /> </div>
          <div style=" position: absolute; top: 186px; left: 536px; "><input id='0' /></div>
          <div style=" position: absolute; top: 186px; left: 574px; "><input id='1' /></div>
          <div style=" position: absolute; top: 186px; left: 613px; "><input id='2' /></div>
          <div style=" position: absolute; top: 369px; left: 104px; "><input id='3' /></div>
          <div style=" position: absolute; top: 369px; left: 143px; "><input id='4' /></div>
          <div style=" position: absolute; top: 369px; left: 181px; "><input id='5' /></div>
          <div style=" position: absolute; top: 369px; left: 518px; "><input id='6' /></div>
          <div style=" position: absolute; top: 369px; left: 554px; "><input id='7' /></div>
          <div style=" position: absolute; top: 369px; left: 592px; "><input id='8' /></div>
          <div style=" position: absolute; top: 369px; left: 628px; "><input id='9' /></div>
          <div style=" position: absolute; top: 369px; left: 665px; "><input id='10' /></div>
          <div style=" position: absolute; top: 518px; left: 357px; "><input id='11' /></div>
          <div style=" position: absolute; top: 518px; left: 397px; "><input id='12' /></div>
          <div style=" position: absolute; top: 518px; left: 434px; "><input id='13' /></div>

        </div>
        `,
        answer: [
          "w",
          "e",
          "t",
          "d",
          "r",
          "y",
          "p",
          "h",
          "o",
          "t",
          "o",
          "b",
          "a",
          "d",
        ],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 12',
    id: 'WB3-U12-P80-E2',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page80/E2/Key/answerKey.png',
    inputSize: 280,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page80/E2/1.jpg' /> </div>
          <div style=" position: absolute; top: 168px; left: 307px; "><input id='0' /></div>
          <div style=" position: absolute; top: 248px; left: 381px; "><input id='1' /></div>
          <div style=" position: absolute; top: 329px; left: 362px; "><input id='2' /></div>
          <div style=" position: absolute; top: 408px; left: 331px; "><input id='3' /></div>


        </div>
        `,
        answer: [
          "good",
          "bad",
          "wet",
          "dry",
        ],
      },
    ],
  },




}
export default json;